import { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

import tailwindCSS from '../styles/tailwind.css?raw';

export const TailwindWrapper = ({ children }) => {
  const hostRef = useRef(null);
  const [shadowRoot, setShadowRoot] = useState(null);

  useEffect(() => {
    if (hostRef.current && !shadowRoot) {
      setShadowRoot(hostRef.current.attachShadow({ mode: 'open' }));
    }
  }, [shadowRoot]);

  useEffect(() => {
    if (shadowRoot) {
      if (!shadowRoot.querySelector('style[data-tailwind]')) {
        const style = document.createElement('style');
        style.setAttribute('data-tailwind', 'tailwind');
        style.textContent = tailwindCSS;
        shadowRoot.appendChild(style);
      }
    }
  }, [shadowRoot]);

  return (
    <div style={{ display: 'contents' }} ref={hostRef}>
      {shadowRoot && ReactDOM.createPortal(children, shadowRoot)}
    </div>
  );
};
